'use strict';

var numeral = require('numeral');
var I18nConfig = function I18nConfig(FormattingConstants, configurationService) {
  var config = FormattingConstants.CONFIG;
  function overrideConfiguration() {
    config.currency.symbol = configurationService.getCurrencySymbol();
  }
  function configureNumeral() {
    var LOCALE = 'en';
    numeral.language(LOCALE, config);
    numeral.language(LOCALE);
  }
  overrideConfiguration();
  configureNumeral();
};
I18nConfig.$inject = ['FormattingConstants', 'ConfigurationService'];
module.exports = I18nConfig;